const matchesFilter = (value: unknown, filter: string) =>
  String(value).toLowerCase().includes(filter);

export const filterByString = <T>(
  data: T[],
  filterString: string,
  fields?: (keyof T)[],
): T[] => {
  if (!filterString) {
    return data;
  }

  const lowerCaseFilterString = filterString.toLowerCase();

  return data.filter((item) => {
    if (fields) {
      return fields.some((field) => {
        const value = item[field];
        return matchesFilter(value, lowerCaseFilterString);
      });
    }
    return typeof item === "object" && item !== null
      ? Object.values(item).some((value) =>
          matchesFilter(value, lowerCaseFilterString),
        )
      : String(item).toLowerCase().includes(lowerCaseFilterString);
  });
};
